import React, { useRef, useEffect } from "react";
import { Text, Transformer } from "react-konva";

export function TextoRedim({x,y,text,isSelected,width,
  height,onResize,onClick,editText,color,tamanio,onFontSize}) {
  const textRef = useRef(null);
  const transformerRef = useRef(null);

  useEffect(() => {
    if (isSelected && transformerRef.current !== null) {
      transformerRef.current.nodes([textRef.current]);
      transformerRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  function handleResize() {
    if (textRef.current !== null) {
      const textNode = textRef.current;
      const newWidth = textNode.width() * textNode.scaleX();
      const newHeight = textNode.height() * textNode.scaleY();
      textNode.setAttrs({
        width: newWidth,
        scaleX: 1
      });
      onResize(newWidth, newHeight);
    }
  }

  const transformer = isSelected ? (
    <Transformer
          ref={transformerRef}
          rotateEnabled={false}
          flipEnabled={false}
          //enabledAnchors={["middle-left", "middle-right","bottom-center","top-center"]}
          boundBoxFunc={(oldBox, newBox) => {
            newBox.width = Math.max(30, newBox.width);
            return newBox;
          }}
        />
  ) : null;

  return (
    <>
      <Text
        x={x}
        y={y}
        ref={textRef}
        text={text}
        fill={color? color : "#000000"}
        fontFamily="sans-serif"
        fontVariant="bold"
        fontSize={tamanio}
        perfectDrawEnabled={false}
        onTransform={handleResize}
        onClick={onClick}
        onTap={onClick}
        width={width}
        height={height}
      />
      {transformer}
    </>
  );
}
